import React, { useState } from "react"
import { Logo } from "../Logo"
import { Box, Button, Link, Icon } from "@ncs/web-legos"
import { useMediaQuery } from "@material-ui/core"
import { useTheme } from "@emotion/react"
import { ContentWrapperEcomm } from "../ContentWrapperEcomm"
import { ShopBarCartSummaryEcomm } from "./ShopBarCartSummaryEcomm"
import { ShopBarSearch } from "./ShopBarSearch"
import { MobileNavModalEcomm } from "../MobileNavModalEcomm"
import { ShopBarUserWelcome } from "../user-welcome/ShopBarUserWelcome"
import {
	logoLinkStyle,
	mobileNavButtonStyle,
	shopBarSearchStyle,
	shopBarContainerStyle,
	outerContainerStyle,
} from "./styles"
import { ShopBarNav } from "./ShopBarNav"

export const ShopBar: React.FC = () => {
	const [showNavModal, setShowNavModal] = useState(false)
	const theme = useTheme()
	const screenIsMediumUp = useMediaQuery(theme.breakpoints.up("md"), { defaultMatches: true })

	return (
		<>
			<div css={outerContainerStyle}>
				<ContentWrapperEcomm>
					<Box
						display="flex"
						columnGap="1rem"
						alignItems="center"
						justifyContent="space-between"
					>
						<div>
							{!screenIsMediumUp && (
								<Button
									onClick={() => setShowNavModal(true)}
									aria-label="Open navigation menu"
									title="Open navigation menu"
									css={mobileNavButtonStyle}
								>
									<Icon icon="bars" color="white" fontSize={1.7} />
								</Button>
							)}
							<Link to="/" css={screenIsMediumUp && logoLinkStyle}>
								{!screenIsMediumUp ?
									<Logo height={1.5} company="ncsWhite" />
								:	<Logo
										height={1.875}
										maxWidth={!screenIsMediumUp ? "7rem" : undefined}
										company="ncsWhite"
									/>
								}
							</Link>
						</div>
						{!screenIsMediumUp && (
							<>
								<ShopBarCartSummaryEcomm />
								<ShopBarUserWelcome />
							</>
						)}

						{screenIsMediumUp && (
							<>
								<ShopBarSearch css={shopBarSearchStyle} />
								<ShopBarUserWelcome />
							</>
						)}
					</Box>
					{!screenIsMediumUp && <ShopBarSearch css={shopBarSearchStyle} />}
				</ContentWrapperEcomm>
			</div>
			{screenIsMediumUp && (
				<div css={shopBarContainerStyle}>
					<ContentWrapperEcomm>
						<Box display="flex" alignItems="center">
							<ShopBarNav />
							<ShopBarCartSummaryEcomm />
						</Box>
					</ContentWrapperEcomm>
				</div>
			)}
			<MobileNavModalEcomm isOpen={showNavModal} onClose={() => setShowNavModal(false)} />
		</>
	)
}
